import { Component, Input, OnInit } from '@angular/core';
import { ContactGroup } from '@app/core/interfaces/c5/contact-group';
import { ReactiveComponent } from '@app/shared/components/reactive-component';
import { sortBy } from '@app/utils/common';
import { ngValueAccessor } from '@app/utils/ng-value-accessor';
import { NumberMap } from '@app/utils/number-map';

@Component({
  selector: 'portal-contact-group-select',
  templateUrl: './contact-group-select.component.html',
  styles: [],
  providers: [ngValueAccessor(ContactGroupSelectComponent)],
  standalone: false,
})
export class ContactGroupSelectComponent extends ReactiveComponent implements OnInit {
  @Input()
  public contactGroups: ContactGroup[];

  public groups: (ContactGroup & { active: boolean })[];

  private groupMap: NumberMap<ContactGroup & { active: boolean }> = {};

  ngOnInit() {
    this.groupMap = {};

    this.contactGroups.forEach((contactGroup) => {
      this.groupMap[contactGroup.id] = {
        ...contactGroup,
        active: false,
      };
    });

    this.groups = Object.values(this.groupMap).sort(sortBy(['name']));
  }

  public emitValue(): void {
    const activeGroups: ContactGroup[] = [];

    Object.keys(this.groupMap).forEach((key) => {
      if (this.groupMap[key].active === true) {
        activeGroups.push(this.groupMap[key]);
      }
    });

    this.onChange(activeGroups);
  }

  public handleChange(groupId: number, event: Event): void {
    const input = event.target as HTMLInputElement;

    this.groupMap[groupId].active = input.checked;

    this.emitValue();
  }

  public writeValue(value: ContactGroup[] | null) {
    if (value != null) {
      Object.keys(this.groupMap).forEach((key) => {
        const group = this.groupMap[key];

        group.active = value.some((contactGroup) => contactGroup.id === group.id);
      });
    }
  }
}
